/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useCouponContext } from "./CouponDataContext";

export function CouponDeleteDialog({
  history,
  id,
  active_value,
  show,
  onHide,
}) {
  const context = useCouponContext();
  // Coupon Context

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const deactivateCoupon = async () => {
    const deactivateUrl = "api/discounts/deactivate/";

    //edit coupon post
    const result = await axios.patch(deactivateUrl + id);
    if (result.data === "success") {
      //setEditSuccessOpen(true);
      //console.log("inactivated");
      context.setRefetch(true);
      setTimeout(() => {
        history.push("/coupons/coupon-list");
      }, 1000);
    } else {
      //setEditErrorOpen(true);
    }
    // server request for deleting product by id
    // refresh list after deletion

    // closing delete modal
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* {isLoading && <ModalProgressBar variant="query" />} */}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Coupon De-Activate
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure to de-activate this coupon?</span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deactivateCoupon}
            className="btn btn-delete btn-elevate"
          >
            Deactivate
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
